import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'div'>

export const SearchFormRow: FC<Props> = ({ className, children, ...props }) => {
  return (
    <div {...props} className={clsx(['flex flex-wrap gap-2', className])}>
      {children}
    </div>
  )
}
